import { graphql } from '@revelio/data-access';

export const GET_NAME_RECS = graphql(`
  query GetNameRecommendations($query: TalentDiscoveryReqV3) {
    talent_discovery_name_recommendations_v3(query: $query) {
      names {
        id
        name
      }
    }
  }
`);

export const isValidSearchString = (str: string) => {
  const nameStringCleaned = str?.trim() || '';

  const nameStringSplit = nameStringCleaned.split(' ');

  return (
    nameStringCleaned.length > 0 &&
    nameStringSplit.some((keyword: string) => keyword.length > 2)
  );
};

export const dedupeNameRecommendations = (
  names: readonly { name: string }[]
): { value: string; label: string }[] => {
  const seen = new Map<string, string>();

  for (const { name } of names) {
    const key = name.trim().toLowerCase();
    if (key && !seen.has(key)) seen.set(key, name.trim());
  }

  return Array.from(seen.values(), (name) => ({ value: name, label: name }));
};
